import DataTableColumnHeader from '@/components/datatable/DataTableColumnHeader.vue';
import HolidaysTableActions from '@/components/holidays/HolidaysTableActions.vue';
import type { Holiday } from '@/types';
import { formatDate } from '@/utils/helpers';
import type { ColumnDef } from '@tanstack/vue-table';
import { h } from 'vue';

export const columns: ColumnDef<Holiday>[] = [
    {
        accessorKey: 'name',
        header: ({ column }) =>
            h(DataTableColumnHeader, {
                column: column,
                title: 'holidays.table.name',
            }),
    },
    {
        accessorKey: 'holiday_date',
        header: ({ column }) =>
            h(DataTableColumnHeader, {
                column: column,
                title: 'holidays.table.date',
            }),
        cell: ({ row }) => {
            return formatDate(row.original.holiday_date);
        },
        filterFn: 'dateRange',
        meta: {
            filterType: 'dateRange',
        },
    },
    {
        id: 'actions',
        enableHiding: false,
        header: ({ column }) =>
            h(DataTableColumnHeader, {
                column: column,
                title: 'tables.actions',
            }),
        cell: ({ row }) => {
            return h(HolidaysTableActions, {
                holiday: row.original,
            });
        },
    },
];
